import { LegalLayout, H1, H2, P, UL } from "./LegalLayout";

export const PrivacyPage = ({ scrollTo }) => (
  <LegalLayout scrollTo={scrollTo} kind="privacy" updated="December 2025">
    <H1>Privacy Policy</H1>
    <P>
      DUNC (&ldquo;DUNC&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) respects your
      privacy. This policy explains what we collect on drinkdunc.com, why we
      collect it, and the choices you have.
    </P>

    <H2>1. What we collect</H2>
    <UL items={[
      "DUNC List sign-ups: name, email, WhatsApp/mobile (optional), city (optional).",
      "Contact & Founder's Batch enquiries: name, email, message, and mobile if you provide it, sent via WhatsApp or our contact form.",
      "Basic technical data: anonymised page views and interactions collected by our analytics tools.",
    ]} />

    <H2>2. How we use it</H2>
    <UL items={[
      "To send you updates about DUNC, drops, and where you can find us — only when relevant.",
      "To respond to your enquiries about the First Sip / Founder's Batch, retail, or partnerships.",
      "To understand which parts of the site work (and which don't) so we can improve it.",
    ]} />

    <H2>3. What we don&apos;t do</H2>
    <UL items={[
      "We do not sell your data.",
      "We do not share your contact details with advertisers.",
      "We do not run automated decisions about you.",
    ]} />

    <H2>4. Storage & retention</H2>
    <P>
      Your data is stored on secured servers and kept only as long as needed to
      operate DUNC — typically the lifetime of your relationship with the brand,
      or until you ask us to remove it.
    </P>

    <H2>5. Your rights</H2>
    <P>
      You can request a copy of your data, ask us to correct it, or ask us to
      delete it at any time. Just message us at <a
        href="https://wa.me/919901234981"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#D9A441] underline decoration-white/20 underline-offset-4"
      >+91 990 1234 981</a> or reply to any DUNC email.
    </P>

    <H2>6. Cookies</H2>
    <P>
      We use a small number of first-party cookies to remember basic preferences
      and to measure site performance. No third-party ad cookies are used.
    </P>

    <H2>7. Changes</H2>
    <P>
      We may update this policy from time to time. Material changes will be
      reflected in the &ldquo;Last updated&rdquo; date above.
    </P>

    <H2>8. Contact</H2>
    <P>
      Questions about privacy? WhatsApp us at{" "}
      <a
        href="https://wa.me/919901234981"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#D9A441] underline decoration-white/20 underline-offset-4"
      >
        +91 990 1234 981
      </a>{" "}
      or use the <a href="/#contact" className="text-[#D9A441] underline decoration-white/20 underline-offset-4">Contact section</a>.
    </P>
  </LegalLayout>
);

export default PrivacyPage;
